import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceflowForm from '@sourceflow-uk/sourceflowform';
import Locations from "../../.sourceflow/locations.json";
import {
    Container,
    Collapse,
    Modal,
    ModalHeader,
    ModalBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import styles from './styles.module.scss';
import { useRouter } from 'next/router';

export default function SimplePage({
    global,
    pathPrefix,
    content,
    customClass = "",
    formId,
    heading,
    textCenter = false,
    page,
    form_header = <p>Let's make sure you get in touch with the right team</p>
}) {
    const [state, setState] = React.useState({});

    const { article } = state;
    React.useEffect(() => {
        setState((prevState) => ({
            moreInfoOpen: true
        }));
        // handleArticleOpen("0");
        handleArticleOpen("");

    }, []);

    const handleArticleOpen = (article) => {
        setState((prevState) => ({
            ...prevState,
            article
        }));

    };
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [selectedItem, setSelectedItem] = useState("Select Branch");


    const [modal, setModal] = useState(false);
    const toggle_modal = () => setModal(!modal);

    
    // LOAD SELECTED FORM BY URL IF APPLICABLE
    const router = useRouter();
    const isPageRecruitStaff = router.asPath === "/recruit-staff/";

    useEffect(() => {
        if (!router.isReady) return;
        const { query } = router;
        if (query && query?.city) {
            let activeCity = Locations?.category_values?.find((city) => city.url_slug === query?.city);
            let activeCityIndex = Locations?.category_values?.findIndex((city) => city.url_slug === query?.city);
            setSelectedItem(`${activeCity.title.en}`)
            handleArticleOpen(`${activeCityIndex}`);
        }
    }, [router.isReady]);
    // END

    return (
        <section className={`${styles.root} ${customClass}`} >
            <Container>
                {content ?
                    <div className={`${textCenter ? "text-center" : ""}`}>
                        <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                            {content}
                        </SourceFlowText>
                    </div> : ""}
                {formId ?
                    <>
                        <div className="mt-5 pb-1">
                            <div className="mb-5 form-wrapper rounded p-4 border">
                                <div className=" p-md-4 ms-md-5 me-md-5">
                                    <h3 className={`${textCenter ? "text-md-center" : ""} mb-4 text-white`}>
                                        <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText></h3>
                                    <div className="d-flex flex-wrap aligm-items-center mb-3 custom-dropdown">
                                        <div className="mb-2 text-white w-100">
                                            <SourceFlowText global={global} path={`${pathPrefix}.form_header`} type="html">
                                                {form_header}
                                            </SourceFlowText>
                                        </div>
                                        {!isPageRecruitStaff ? (
                                            <Dropdown isOpen={dropdownOpen} toggle={toggle} className="pe-md-3">
                                                <DropdownToggle>{selectedItem}</DropdownToggle>
                                                <DropdownMenu>
                                                    {Locations.category_values?.map((post, index) => (
                                                        post?.sourceflow_embed_form_api.en ?
                                                            <DropdownItem key={index} onClick={() => { handleArticleOpen(`${index}`); setSelectedItem(`${post.title.en}`) }} className={`${article === `${index}` ? "active" : ""}`}>{post.title.en}</DropdownItem>
                                                            : ""
                                                    ))}
                                                </DropdownMenu>
                                            </Dropdown>
                                        ) : (
                                            <SourceflowForm onSubmitDone={toggle_modal} formId="bfb1f613-66ce-400f-a39d-80a248329c39" />
                                        )}
                                    </div>

                                    {Locations.category_values?.map((post, index) => (
                                        post?.sourceflow_embed_form_api.en ?
                                            <Collapse isOpen={article === `${index}`} key={index}>
                                                <SourceflowForm onSubmitDone={toggle_modal} formId={post.sourceflow_embed_form_api.en} />
                                            </Collapse> : ""))}
                                </div>
                            </div>
                        </div>
                    </>
                    : ""}
                {modal ?
                    <Modal isOpen={modal} toggle={toggle_modal}>
                        <ModalHeader toggle={toggle_modal} tag={"div"}>
                            <div className="w-100 text-center">
                                <h5 className="heading mb-0"><strong>Submission Successful</strong></h5>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <p>We'll be in touch soon</p>
                        </ModalBody>
                    </Modal> : null
                }
                {page ?
                    <div dangerouslySetInnerHTML={{ __html: page?.content }} />
                    : ""}
                {page?.form ?
                    <div className="mt-5 pb-1">
                        <div className="mb-5 form-wrapper rounded p-4 border">
                            <div className=" p-md-4 ms-md-5 me-md-5">
                                <SourceflowForm onSubmitDone={toggle_modal} formId={page.form} />
                            </div>
                        </div>
                    </div>
                : ""}
            </Container>
        </section>
    )
}